import { render, staticRenderFns } from "./AuthorizeNetLanding.vue?vue&type=template&id=10071904"
import script from "./AuthorizeNetLanding.vue?vue&type=script&lang=js"
export * from "./AuthorizeNetLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports